export const tagSelectAll = () => {

  const button = $('.js-select-all-btn');

  if(!button.length > 0) return

  button.on('click', (e) => {
    e.preventDefault();

    let inputElements = e.target.dataset.target;

    if (inputElements) {

      if ($(inputElements).first().is(':checked')) {
        $(inputElements).prop('checked', true);
        $(inputElements).trigger('click');
        return
      }

      $(inputElements).prop('checked', false);
      $(inputElements).trigger('click');
    }
  });

}
